module.exports = __webpack_public_path__ + "static/media/sf-trial-3.e665e82e.mp3";